<header>
    <app-header></app-header>
  </header> 

  <div class="outer-conatiner">
    <div class="inner-container form-container">
      <div class="code-enf-wrapper ">
       <div class="display-flex"> <app-page-title class="test" [pageTitle]="isAddressSearch ? 'Search Address' : 'Search Case'">
        </app-page-title>
    </div>
        <div>
            <form [formGroup]="searchForm" (ngSubmit)="onSubmitSearch()">
              <div class="row" style="width:120%;" *ngIf="isAddressSearch">
                <div class="col-6">
                    <mat-form-field class="mat-date-pick" style="width:100%;">
                      <mat-label>Street No.</mat-label>
                      <input matInput formControlName="streetNo" pattern="^[a-zA-Z0-9\-_]{0,40}$"required />
                      <mat-error *ngIf="searchForm.get('streetNo').hasError('required')">
                        Please enter Street number
                      </mat-error>
                      <mat-error  *ngIf="!searchForm.get('streetNo').hasError('required') && searchForm.get('streetNo').hasError('pattern')">
                        Street.No. should be without spaces.
                      </mat-error>
                    </mat-form-field>
                  </div>
                <div class="col-6">
                  <mat-form-field class="mat-date-pick" style="width:110%;">
                    <mat-label>Street</mat-label>
                    <!-- <input matInput formControlName="state"/> -->
                    <mat-select formControlName="streetId" required>
                      <mat-option *ngFor="let state of streets" [value]="state.id">{{state.street}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="searchForm.get('streetId').hasError('required')">
                      Please enter street
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row" style="width:150%;" *ngIf="!isAddressSearch">
                <mat-form-field class="mat-date-pick">
                  <mat-label>Case Id.</mat-label>
                  <input matInput formControlName="caseId" pattern="^[a-zA-Z0-9\-_]{0,40}$"required />
                  <mat-error *ngIf="searchForm.get('caseId').hasError('required')">
                    Please enter Case Id
                  </mat-error>
                  <mat-error  *ngIf="!searchForm.get('caseId').hasError('required') && searchForm.get('caseId').hasError('pattern')">
                    Street.No. should be without spaces.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-4 display-flex">
                <button mat-button class="button-primary no-margin" [disabled]='searchForm.invalid'
                  color="vov-ui-primary">Search</button>
                  <!-- <span ><button style="padding-top: 15px;" type="reset" class="semi-button semi-reset"  color="vov-ui-primary" (click)="reset()">Return to Reset</button></span>  -->
              </div>
            </form>
        </div>
      </div>
    </div>
  <p *ngIf="caseData.length == 0" class="nodata">No Data Found</p>       
  <app-spinner *ngIf="showSpinner; else content"></app-spinner>   
  <ng-template #content>
  <div  *ngIf="caseData.length"> 
    <h3 *ngIf="isAddressSearch" style="color: #9B9B9B" class="header-enf">Showing Results for<span style="padding:5px;color:#000">{{searchForm.get('streetNo').value}}  {{selectedAddress.street}}</span></h3>
     <!-- <app-table [tableData]="caseData"  [tableColumnsNames]="columnNames"></app-table>  -->
    <app-case-listing [tableData]="caseData"></app-case-listing>
  </div>
   </ng-template> 
</div>